import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import { useParams, Navigate, useNavigate } from "react-router-dom";
import CoursesData from "../../data/CourseData";
import LoginModal from "../header/LoginModal";
import { useAuth } from "../../context/AuthContext";

const CoursePlayer = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(true);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const { id } = useParams();
    const course = CoursesData.find((c) => c.id === id);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [selectedLessonsTitle, setSelectedLessonsTitle] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const handleLogout = () => {
        logout();
        setTimeout(() => {
            navigate("/");
        }, 100);
    };

    const handleResize = () => {
        const mobile = window.innerWidth <= 768;
        setIsMobile(mobile);
        if (!mobile) {
            setIsMenuOpen(true); // Mostrar menú en pantallas grandes
        }
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (!user || !course) return;

        const savedVideo = localStorage.getItem(`lastVideo-${user.id}-${course.id}`);
        const savedTitle = localStorage.getItem(`lastTitle-${user.id}-${course.id}`);
        if (savedVideo) {
            setSelectedVideo(savedVideo);
            setSelectedLessonsTitle(savedTitle);
        } else if (course.modules.length > 0) {
            const firstLesson = course.modules[0].lessons[0];
            if (firstLesson) {
                const url = `https://www.youtube-nocookie.com/watch?v=${firstLesson.youtubeId}&modestbranding=1&rel=0&controls=1&showinfo=0`;
                setSelectedVideo(url);
                setSelectedLessonsTitle(firstLesson.title);
            }
        }
    }, [course, user]);

    const handleVideoSelect = (lesson) => {
        const videoUrl = `https://www.youtube-nocookie.com/watch?v=${lesson.youtubeId}&modestbranding=1&rel=0&controls=1&showinfo=0`;
        setSelectedVideo(videoUrl);
        setSelectedLessonsTitle(lesson.title);
        localStorage.setItem(`lastVideo-${user.id}-${course.id}`, videoUrl);
        localStorage.setItem(`lastTitle-${user.id}-${course.id}`, lesson.title);
    };

    if (!user) return <Navigate to="/" replace />;
    if (!course) return <div>Curso no encontrado</div>;
    if (!selectedVideo) return <div>Cargando curso...</div>;

    const paymentStatus = user?.paymentStatus?.[course.id] || "full";
    const totalModules = course.modules.length;
    const canAccessFullCourse = paymentStatus === "full";

    return (
        <>
            {showLoginModal && <LoginModal closeModal={() => setShowLoginModal(false)} />}

            {/* HEADER */}
            <header style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px 20px',
                backgroundColor: '#f5f5f5',
                borderBottom: '1px solid #ddd'
            }}>
                <h3>Hola, {user?.name || "Estudiante"}</h3>
                <button
                    onClick={handleLogout}
                    style={{
                        backgroundColor: '#ff4d4d',
                        color: '#fff',
                        border: 'none',
                        padding: '8px 16px',
                        cursor: 'pointer',
                        borderRadius: '4px'
                    }}
                >
                    Cerrar sesión
                </button>
            </header>

            {/* MAIN CONTENT */}
            <div style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                height: "100vh",
                overflow: "hidden"
            }}>

                {/* VIDEO Y TÍTULO */}
                <div style={{
                    flex: 1,
                    background: "#002849",
                    color: "#cecccc",
                    display: "flex",
                    flexDirection: "column"
                }}>
                    {isMobile && (
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px 20px",
                            borderBottom: "1px solid #eee"
                        }}>
                            <button onClick={() => setIsMenuOpen(!isMenuOpen)} style={{ fontSize: "1.5rem", backgroundColor: "#cecccc" }}>⇚</button>
                            <span style={{ fontWeight: "bold", fontSize: "100%", color: "white" }}>MÓDULO DE CLASES</span>
                        </div>
                    )}

                    <div style={{ textAlign: "center", padding: "1", background: "lavender" }}>
                        <h3>{selectedLessonsTitle}</h3>
                    </div>
                    <span style={{ fontWeight: "bold", fontSize: "100%", color: "white", textAlign: "center" }}>MÓDULO DE CLASES</span>

                    <div style={{
                        flex: 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "20px"
                    }}>
                        <div style={{ width: "100%", maxWidth: "1000px", aspectRatio: "16/9" }}>
                            <ReactPlayer
                                url={selectedVideo}
                                controls
                                width="100%"
                                height="100%"
                            />
                        </div>
                    </div>
                </div>

                {/* SIDEBAR - MÓDULOS */}
                {(isMenuOpen || !isMobile) && (
                    <div style={{
                        width: isMobile ? "100%" : "30%",
                        background: "#002849",
                        overflowY: "auto",
                        borderRight: isMobile ? "none" : "1px solid #ddd",
                        padding: "20px"
                    }}>
                        <h2 style={{
                            fontSize: "1.5rem",
                            marginBottom: "1rem",
                            textAlign: "center",
                            color: "white"
                        }}>
                            {course.titleMain} 🚀
                        </h2>
                        <hr style={{ backgroundColor: "white" }} />
                        <div className='accordion-container'>
  {course.modules.map((module, idx) => {
    const isModuleAccessible =
      paymentStatus === 'full' || idx < Math.ceil(totalModules / 2);

    return (
      <div key={idx} className='accordion-item'>
        <button
          className={`accordion-header ${activeIndex === idx ? 'active' : ''}`}
          onClick={() => toggleAccordion(idx)}
        >
          <h4 style={{ color: 'white', fontSize: '100%' }}>{module.title}</h4>
          <span className='arrow'>{activeIndex === idx ? '▲' : '▼'}</span>
        </button>

        <div className={`accordion-content ${activeIndex === idx ? 'show' : ''}`}>
          {isModuleAccessible ? (
            <ul style={{ paddingLeft: '15px' }}>
              {module.lessons.map((lesson, i) => (
                <li
                  key={i}
                  style={{ cursor: 'pointer', marginBottom: '8px', color: 'black' }}
                  onClick={() => handleVideoSelect(lesson)}
                >
                  {lesson.title}
                </li>
              ))}
            </ul>
          ) : (
            <p style={{ color: 'gray', padding: '10px' }}>
              🔒 Módulo bloqueado. Completa el pago del curso para acceder a este contenido.
            </p>
          )}
        </div>
      </div>
    );
  })}
</div>

                    </div>
                )}
            </div>
        </>
    );
};

export default CoursePlayer;
